var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-layout"},[_c('div',{staticClass:"card-layout__languages"},[_c('languages',{attrs:{"variant":"link","toggle-class":"card-layout__language-selector"}})],1),_c('div',{staticClass:"card-layout__card"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }